/** Textarea + `state`; optional character count (`showCharacterCount` + `maxLength`). */
import React, { useMemo, useState } from 'react';
import { cn } from '../cn';
import { getFieldBaseStyle, getFieldColors } from './fieldStyles';
export const Textarea = ({ state = 'default', className, disabled, readOnly, value, defaultValue, onFocus, onBlur, maxLength, showCharacterCount = true, ...props }) => {
    const effectiveState = disabled ? 'disabled' : readOnly ? 'readonly' : state;
    const [focused, setFocused] = useState(false);
    const [hovered, setHovered] = useState(false);
    const focusColors = getFieldColors(effectiveState);
    const borderWidth = effectiveState === 'error' || effectiveState === 'success' || focused
        ? 'var(--stroke-active, 1.5px)'
        : 'var(--stroke-normal, 1px)';
    const borderColor = focused
        ? focusColors.border
        : hovered
            ? 'var(--form-border-hover, rgba(11,18,32,0.36))'
            : 'var(--form-border, rgba(11,18,32,0.22))';
    const ringShadow = focused && effectiveState !== 'readonly' && effectiveState !== 'disabled'
        ? `0 0 0 3px ${focusColors.ring}`
        : 'none';
    const wrapperStyle = {
        ...getFieldBaseStyle(effectiveState),
        borderStyle: 'solid',
        borderWidth,
        borderColor,
        borderRadius: 'var(--radius-md, 8px)',
        boxShadow: ringShadow,
        opacity: effectiveState === 'disabled' ? 0.6 : 1,
        transition: 'all 150ms ease',
    };
    const currentLen = useMemo(() => {
        var _a;
        const v = (_a = value !== null && value !== void 0 ? value : defaultValue) !== null && _a !== void 0 ? _a : '';
        return String(v).length;
    }, [value, defaultValue]);
    return (React.createElement("div", { className: "w-full" },
        React.createElement("div", { className: cn('w-full p-3', className), style: wrapperStyle, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) },
            React.createElement("textarea", { ...props, disabled: effectiveState === 'disabled' ? true : undefined, readOnly: effectiveState === 'readonly' ? true : readOnly, value: value, defaultValue: defaultValue, maxLength: maxLength, onFocus: (e) => {
                    setFocused(true);
                    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
                }, onBlur: (e) => {
                    setFocused(false);
                    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
                }, className: "block min-h-[96px] w-full resize-y bg-transparent text-[length:var(--text-body,14px)] text-[color:var(--form-fg,#0b1220)] outline-none placeholder:text-[color:var(--form-placeholder,rgba(11,18,32,0.38))]" })),
        showCharacterCount && maxLength != null ? (React.createElement("div", { className: "mt-[var(--form-field-gap,6px)] text-right text-[length:var(--text-hint,12px)] text-[color:var(--form-fg-muted,rgba(11,18,32,0.66))]" },
            currentLen,
            "/",
            maxLength)) : null));
};
export default Textarea;
